import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://casa-elio-sjds.emergent.host";
const DEFAULT_IMAGE =
  "https://cf.bstatic.com/xdata/images/hotel/max1920x1080/843224454.jpg?k=894ff71907381a3559eb93430569bc12e3557bd0a1d0460422834df363ba523d&o=";

/**
 * Per-page SEO meta. Sets <title>, description, canonical, OpenGraph and
 * Twitter tags. Used on each route to override the index.html defaults.
 */
const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noIndex = false,
}) => {
  const fullTitle = title
    ? `${title} — Casa Elio`
    : "Casa Elio — Boutique Villa in San Juan del Sur, Nicaragua";
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex ? <meta name="robots" content="noindex, nofollow" /> : null}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
